import NotificationsController    from "@/js/Webmail/Notifications/NotificationsController";
import MessagesOptionsHTTPMapping from "./HTTP/MessagesOptionsHTTPMapping";
import MessagesOptionsHTTPService from "./HTTP/MessagesOptionsHTTPService";
import MessagesOptionsItem        from "./Collections/MessagesOptionsItem";

export { MessagesOptionsControllerSingleton as default };

/**
* Email Messages Options Controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesOptionsController {
  /**
   * Messages Options
   *
   * @public
   *
   * @type {MessagesOptionsItem}
   *
   * @since 7.0.0
   */
  options = new MessagesOptionsItem();

  /**
   * HTTP Mapping object
   *
   * @private
   *
   * @type {MessagesOptionsHTTPMapping}
   *
   * @since 7.0.0
   */
  http_mapping = new MessagesOptionsHTTPMapping();

  /**
   * HTTP Service object
   *
   * @private
   *
   * @type {MessagesOptionsHTTPService}
   *
   * @since 7.0.0
   */
  http_service = new MessagesOptionsHTTPService();

  /**
   * Fetchs messages options from APi Service
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<boolean>}
   */
  async fetchOptions() {
    let response = await this.http_service.fetchOptions();

    if (response.success === false) {
      NotificationsController.addMessage('notifications.', response.messages);
      return false;
    }

    this.http_mapping.map(this.options, response);
    return response.success;
  }

  /**
   * Saves messages options in APi Service
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<boolean>}
   */
  async saveOptions() {
    let response = await this.http_service.saveOptions(this.options);
    NotificationsController.addMessage('notifications.', response.messages);

    return await this.fetchOptions();
  }

  /**
   * Sets the Message options from a given object
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} options
   *
   * @return {void}
   */
    setOptions(options) {
      this.http_mapping.mapFromObject(this.options, options);
    }
}

/**
 * @type {MessagesOptionsController}
 */
const MessagesOptionsControllerSingleton = new MessagesOptionsController();